import { createLazyFileRoute } from '@tanstack/react-router'

import FoodOrderDetails from '@/views/Account/FoodOrders/FoodOrderDetails'

export const Route = createLazyFileRoute('/_account/food-orders/$foodOrderId/')(
  {
    component: FoodOrderDetails,
  },
)
